export default __webpack_public_path__ + "static/media/p1.b7394a17.jpg";